// extracted by mini-css-extract-plugin
export default {"container":"touchable_container__5unel"};